import draftToHtml from './draftjsToHtml/js';

export type DraftEntity = {type: string; mutability?: string; data: Record<string, unknown>};

export type CustomEntityTransform = (entity: DraftEntity, text: string) => string | undefined;

export const convertFromDraftJsToHtml = (draftJsOrHtml: string, customEntityTransform?: CustomEntityTransform): string => {
	if (!draftJsOrHtml) {
		return '';
	}
	try {
		/* if the contents is not valid json, we assume it to the html or text and return it directly*/
		const json = JSON.parse(draftJsOrHtml);
		if (json.blocks.length === 0) {
			return draftJsOrHtml;
		}
		return draftToHtml(json, undefined, undefined, customEntityTransform);
	} catch (e) {
		return draftJsOrHtml;
	}
};
